import JwtPayload from '@/entities/api/jwt'

const getPermissionsMap = (permissionsArray: JwtPayload['permissions']) => {
	return permissionsArray.reduce((acc, { module, ...rest }) => {
		acc[module] = rest
		return acc
	}, {} as Record<string, Omit<(typeof permissionsArray)[0], 'module' | '_id'>>)
}

export default getPermissionsMap
